var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button-input',{staticClass:"back-button",nativeOn:{"click":function($event){return _vm.onClick.apply(null, arguments)}}},[_c('arrow-left',{attrs:{"slot":"icon","fill":"white"},slot:"icon"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }